import React from 'react';

import Authorization from '@appComponents/Authorization';
import LinkWithAuthorization from '@appComponents/LinkWithAuthorization';
import {convertToInt} from '@utils/helpers';
import {prepareClients, prepareEventContents, renderUsages} from '@modules/events/utils/eventGeoRestrictionsHelper';
import {getTerritoriesWithTooltip} from '@utils/countryHelpers';
import {generateBlackoutZonesRow} from '@utils/blackoutZones';
import {IconWithTooltip} from '@appComponents/IconCollection';
import {getLink} from '@appComponents/Link';
import * as RESOURCES from '@constants/resources';
import * as CONST from '@constants/variables';

export const authorizationObject = {
    [RESOURCES.EVENT_GEO_RESTRICTION]: CONST.SECURITY_PRIVILEGES_READ,
};

export const rowRenderer = (column, row, data, eventId, history) => {
    switch (column) {
        case 'id':
            return (
                <LinkWithAuthorization
                    authorization={authorizationObject}
                    link={{
                        name: 'events.geoRestrictions.editGeneralInformation',
                        params: {
                            id: eventId,
                            restrictionId: convertToInt(row.id),
                        },
                    }}
                >
                    {row[column]}
                </LinkWithAuthorization>
            );
        case 'clients':
            return prepareClients(row, column);
        case 'event_contents':
            return prepareEventContents(row, column);
        case 'usages':
            return renderUsages(row[column]);
        case 'countries':
            return getTerritoriesWithTooltip(row, data.mappedIsoCodes);
        case 'blackoutZones':
            return generateBlackoutZonesRow(row.blackout_zones);
        case 'actions': {
            return (
                <Authorization
                    authorization={authorizationObject}
                >
                    <div className='actions-list-icon'>
                        <IconWithTooltip
                            iconProps={{
                                size: 'large',
                                className: '--withPointer',
                                corner: 'top right',
                            }}
                            name='edit'
                            onClick={() => {
                                history.push(getLink('events.geoRestrictions.editGeneralInformation', {
                                    id: eventId,
                                    restrictionId: convertToInt(row.id),
                                }));
                            }}
                            tooltip={'General information'}
                            popupProps={{position: 'top right'}}
                        />
                        <IconWithTooltip
                            iconProps={{
                                size: 'large',
                                className: '--withPointer',
                                corner: 'top right',
                            }}
                            name='globe'
                            onClick={() => {
                                history.push(getLink('events.geoRestrictions.editGeoRestrictions', {
                                    id: eventId,
                                    restrictionId: convertToInt(row.id),
                                }));
                            }}
                            tooltip={'Geo restrictions'}
                            popupProps={{position: 'top right'}}
                        />
                        <IconWithTooltip
                            iconProps={{
                                size: 'large',
                                className: '--withPointer',
                                corner: 'top right',
                            }}
                            name='shield'
                            onClick={() => {
                                history.push(getLink('events.geoRestrictions.blackoutZones', {
                                    id: eventId,
                                    restrictionId: convertToInt(row.id),
                                }));
                            }}
                            tooltip={'Blackout Zones'}
                            popupProps={{position: 'top right'}}
                        />
                    </div>
                </Authorization>
            );
        }
        default: {
            return null;
        }
    }
};
